import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useApi, errMsg } from "@/lib/api";
import { Loader, EmptyState } from "@/components/common";

export default function Help() {
  const api = useApi();
  const [state, setState] = useState({});
  useEffect(() => {
    api("get", "/support").then((s) => setState({ id: s.user_id })).catch((e) => setState({ error: errMsg(e) }));
  }, [api]);
  if (state.id) return <Navigate to={`/messages/${state.id}`} replace />;
  if (state.error) return <EmptyState testId="help-error" title="Help" text={`${state.error}. You can also use the contact form.`} />;
  return <Loader />;
}
